import { StatTableCellProps } from "components/StatsTable/StatTableColumn";
import { asPercentageString } from "Utility";
import { StatCell, Stat, StatBreakdown } from "../styles";
import {
  DEFAULT_FRACTION_DIGITS,
  StatTablePercentColumn,
} from "./PercentColumn";

interface Props<T> extends StatTableCellProps<T, StatTablePercentColumn<T>> {}

export function StatTablePercentCell<T>({
  stats,
  column,
  columnIdx,
  frozenOffset,
}: Props<T>) {
  const rate = column.rateGetter(stats);
  const breakdown = !!column.subTextGetter
    ? column.subTextGetter(stats)
    : undefined;
  const percentString =
    rate !== undefined
      ? asPercentageString(
          rate,
          column.fractionDigits ?? DEFAULT_FRACTION_DIGITS
        )
      : "-";

  return (
    <StatCell
      key={`${columnIdx} percent ${rate}`}
      highlight={column.highlight}
      frozenWidth={column.frozenWidth}
      frozenOffset={frozenOffset}
      border={column.border}
    >
      <Stat>{percentString}</Stat>
      <br />
      <StatBreakdown>{breakdown}</StatBreakdown>
    </StatCell>
  );
}
